import React from "react";
import { useIntl } from "react-intl";
import { PeekButton, PeekIconButton, PeekStack, PeekTextField, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import { Trash3 } from "@piiqtechnologies/svg-icons";
import messages from "../../../messages.i18n";
export const DiscoverOrganizationIds = ({ organizationIds, onOrganizationIdsChange }) => {
    const intl = useIntl();
    const theme = useTheme();
    const handleAddOrganization = () => {
        onOrganizationIdsChange([...organizationIds, ""]);
    };
    const handleOrganizationChange = (index, value) => {
        const newIds = [...organizationIds];
        newIds[index] = value;
        onOrganizationIdsChange(newIds);
    };
    const handleDeleteOrganization = (index) => {
        const newIds = organizationIds.filter((_, i) => i !== index);
        onOrganizationIdsChange(newIds.length > 0 ? newIds : [""]);
    };
    const allFieldsFilled = organizationIds.every((id) => (id === null || id === void 0 ? void 0 : id.trim()) !== "");
    return (React.createElement(PeekStack, { spacing: 0.5 },
        React.createElement(PeekTypography, { variant: "body2", color: "error", fontWeight: 500 },
            intl.formatMessage(messages.addOrganization),
            " ",
            React.createElement("span", { style: { fontWeight: 400 } }, intl.formatMessage(messages.discoverOrganizationRequired))),
        React.createElement(PeekStack, { spacing: 0.5 }, organizationIds.map((id, index) => (React.createElement(PeekStack, { key: index, direction: "row", alignItems: "center", spacing: 1 },
            React.createElement(PeekTextField, { value: id, onChange: (e) => handleOrganizationChange(index, e.target.value), placeholder: intl.formatMessage(messages.organizationIdPlaceholder), variant: "standard", fullWidth: true, InputProps: {
                    disableUnderline: true,
                } }),
            React.createElement(PeekIconButton, { size: "small", onClick: () => handleDeleteOrganization(index), sx: {
                    color: theme.palette.grey[500],
                    "&:hover": {
                        color: theme.palette.error.main,
                    },
                } },
                React.createElement(Trash3, null)))))),
        React.createElement(PeekStack, { alignItems: "center" },
            React.createElement(PeekButton, { variant: "outlined", color: "info", onClick: handleAddOrganization, disabled: !allFieldsFilled }, intl.formatMessage(messages.addAnotherOrganization)))));
};
export default DiscoverOrganizationIds;
